@if (apiLoading$ | async) {
  <div class="overlay">
    <cx-spinner></cx-spinner>
  </div>
}
@if (productCode) {
  <form [formGroup]="addToCartForm" (submit)="addToCart()">
    @if (showQuantity) {
      <div class="quantity">
        <udx-product-summary></udx-product-summary>
        <div class="container cart-margin">
          @if (product?.variantOptions != undefined && product.udxProductType != 'EXPRESS') {
            <div>
              <!-- Raj: Base product express type is not supposed to show variant options yet in the base PDP! USJCOMM-2297 -->
              <!-- Hiding the lable on the basis of the basesite, needed for USJ not for USH -->
              @if (currentBaseSite == 'b2bportal') {
                <span class="label-font">{{ 'pdp.selectQuantity' | cxTranslate }}</span>
              }
              @if (product?.productVariantSelector == 'SINGLE_SELECT') {
                <div class="row mt-3">
                  @for (option of product?.variantOptions; track option) {
                    <div class="col-12 mb-2">
                      <button
                        id="singleSelect"
                        type="button"
                        class="btn btn-primary single-select"
                        [ngClass]="{ 'single-option-selected': activeSingleSelectButton == option.code }"
                        (click)="singleSelectButtonClickHandler(option)"
                        style="width: 100%"
                        >
                        {{ option.name }}
                      </button>
                    </div>
                  }
                  @if (!!currentSingleSelectedOption) {
                    <div
                      class="col-12 mt-2"
                      style="padding-left: 35px !important; padding-right: 0px !important"
                      >
                      <div class="row">
                        @if(fieldEnabled){
                          <div class="col-12 col-md-2 text-left" style="margin-top: 15px !important ; font-size:small;font-weight: bold;">{{ 'common.startingFrom' | cxTranslate }}</div>
                        }
                        <div class="col-md-2 col-12  variant-price" style="margin-top: 15px !important">
                          {{ currentSingleSelectedOption.startingPrice?.formattedValue }}
                        </div>
                        <div class="col-md-8 col-12">
                          <app-item-counter
                            [max]="currentSingleSelectedOption.maxQty"
                            [min]="currentSingleSelectedOption.minQty"
                            [allowZero]="true"
                            [control]="$any(addToCartForm.get('quantity'))"
                            (quantityChanged)="onQuantityChanged($event,currentSingleSelectedOption.hideOnCart)"
                            style="width: 100%"
                          ></app-item-counter>
                        </div>
                        @if (currentSingleSelectedOption.stock?.stockLevelStatus === 'outOfStock') {
                          <div
                            class="col"
                            style="margin-top: 15px !important"
                            >
                            <div class="text-danger">
                              <small class="group-type-age-label"
                                ><b>{{ 'addToCart.outOfStock' | cxTranslate }}</b></small
                                >
                              </div>
                            </div>
                          }
                          @if (currentSingleSelectedOption.stock?.stockLevelStatus !== 'outOfStock') {
                            <div
                              class="col"
                              style="margin-top: 15px !important"
                              >
                              @if(currentBaseSite == 'b2bportal'){
                                <small class="group-type-age-label">
                                  <!-- <b *ngIf="currentSingleSelectedOption.minQty">{{
                                  'common.productMinVal' | cxTranslate : { minVal: currentSingleSelectedOption.minQty }
                                }}</b>
                                <b *ngIf="currentSingleSelectedOption.minQty && currentSingleSelectedOption.maxQty">, </b>
                                <b *ngIf="currentSingleSelectedOption.maxQty">{{
                                  'common.productMaxVal' | cxTranslate : { maxVal: currentSingleSelectedOption.maxQty }
                                }}</b> -->
                                (
                                {{ currentSingleSelectedOption.minQty }}
                                ~
                                {{ currentSingleSelectedOption.maxQty }}
                                )
                              </small>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
              @if (product?.productVariantSelector != 'SINGLE_SELECT') {
                <div>
                  @for (option of product?.variantOptions; track option) {
                    <div class="row mt-3" style="align-items: center;">
                      <div class="{{ usjfeature ? 'col-4 pl-0 text-break' : 'col-12 col-md-4 text-left variant-price'}}">
                        <div class="group-type">
                          {{ option.name }}
                          <!-- <ng-container *ngIf="!appConstants.HIDE_AGE_CATEGORY_DISPLAY"> -->
                          <small class="group-type-age-label">{{ 'pdp.ageGroup.' + option.ageCategory | cxTranslate }}</small>
                        <!-- </ng-container> -->
                      </div>
                    </div>
                    @if(fieldEnabled){
                      <div class="col-12 col-md-2 text-left" style="margin-top: 15px !important ; font-size:small;font-weight: bold;">{{ 'common.startingFrom' | cxTranslate }}</div>
                    }
                    @if(!usjfeature){
                      <div class="col-12 col-md-2 text-left variant-price">{{ option.startingPrice?.formattedValue }}</div>
                    }
                    @else {
                    <div class="col-2 text-left variant-price">@if (option.startingPrice?.formattedValue) {
                      <span>{{ option.startingPrice?.formattedValue }}~ {{ 'productDetails.taxIncluded' | cxTranslate }}</span>
                    } </div>
                  }
                  <div class="{{ usjfeature ? 'col-4' : 'col-md-8 col-12' }}">
                    <app-item-counter
                      [max]="option.maxQty"
                      [min]="option.minQty"
                      [allowZero]="true"
                      [control]="$any(addToCartForm.get(option.code!))"
                      (quantityChanged)="onQuantityChanged($event,option.hideOnCart)"
                    ></app-item-counter>
                  </div>
                  @if (option.stock?.stockLevelStatus === 'outOfStock') {
                    <div class="{{ usjfeature ? 'col-2' : 'col' }} text-danger">
                      <small class="group-type-age-label"
                        ><b>{{ 'addToCart.outOfStock' | cxTranslate }}</b></small
                        >
                      </div>
                    }
                    @if (option.stock?.stockLevelStatus !== 'outOfStock') {
                      <div class="{{ usjfeature ? 'col-2' : 'col' }}">
                        @if(usjfeature){
                          <small class="group-type-age-label">
                            (
                            {{ option.minQty }}
                            ~
                            {{ option.maxQty }}
                            )
                          </small>
                        }
                      </div>
                    }
                  </div>
                }
                @if(currentBaseSite == 'b2bportal'){
                  <span class="ticket-disclaimer"> {{ 'pdp.priceDisclaimer' | cxTranslate}} </span>
                }
                @else if(currentBaseSite == 'b2bportal_lv'){
                <span class="ticket-disclaimer"> {{ 'pdp.priceDisNA' | cxTranslate }} {{taxEnabled | cxTranslate}}</span>
              }
              @else if(currentBaseSite == 'b2bportal_ush' || (currentBaseSite == 'ukrfr_b2bportal')){
              <span class="ticket-disclaimer"> {{ 'pdp.priceDisNAUSHUKR' | cxTranslate }} </span>
            }
          </div>
        }
        <div class="row mt-5">
          @if (product.annualPassAvailableDates) {
            <div class="col">
              <div class="label-font">
                {{ 'pdp.blockOutDates' | cxTranslate }}
              </div>
              <mat-form-field appearance="fill">
                <mat-label>{{ 'pdp.clickDateIcon' | cxTranslate }}</mat-label>
                <input matInput [matDatepicker]="blockOut" [matDatepickerFilter]="dateFilter" disabled />
                <mat-datepicker-toggle matSuffix [for]="blockOut"></mat-datepicker-toggle>
                <mat-datepicker #blockOut [dateClass]="blockOutDateCell" [disabled]="false"></mat-datepicker>
              </mat-form-field>
            </div>
          }
          @if (product.dateSelectionRequired) {
            <div class="col">
              @if(currentBaseSite == 'b2bportal'){
                <div class="label-font">
                  {{ 'pdp.selectVisitationDate' | cxTranslate }}
                </div>
              }
              @else {
              <div class="label-font">
                {{ 'pdp.selectVisitDateNA' | cxTranslate }}
              </div>
            }
            <mat-form-field appearance="fill">
              <mat-label>{{ 'pdp.datelabel' | cxTranslate :{datelabel:dateLabel} }}</mat-label>
              <input
                matInput
                [matDatepickerFilter]="dateFilter"
                (dateChange)="dateSelected($event)"
                [matDatepicker]="dp"
                formControlName="datePicker"
                [class.black-text]="isDateSelected"
                />
              <mat-datepicker-toggle matSuffix [for]="dp" (click)="onPickerToggle()" [class.black-text]="isDateSelected"></mat-datepicker-toggle>
              <mat-datepicker #dp [disabled]="isDateSelectionDisabled"></mat-datepicker>
            </mat-form-field>
            @if (isLoadingDates) {
              <mat-spinner></mat-spinner>
            }
          </div>
        }
        @if (product.timeSelectionRequired) {
          <div class="col">
            @if(currentBaseSite == 'b2bportal'){
              <div class="label-font">
                {{ 'pdp.selecttimeslot' | cxTranslate }}
              </div>
            }
            @else {
            <div class="label-font">
              {{ 'pdp.selectVisitTimeNa' | cxTranslate }}
            </div>
          }
          <mat-form-field appearance="fill">
            <mat-label></mat-label>
            <mat-select
              formControlName="timeSlotPicker"
              name="time"
              (selectionChange)="timeSlotSelected($event)"
              [value]="timeSlots.size === 1 ? getDefaultPerfomance() : null"
              >
              @for (time of timeSlots; track time) {
                <mat-option [value]="time">
                  {{ time }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    </div>
    @if(!usjfeature) {
      <div class="subtotal">{{ 'pdp.subtotal' | cxTranslate }}{{ subtotal | async |currency:defaultCurrencyISO }}</div>
    }
    @else {
    <div class="subtotal">{{ 'pdp.subtotal' | cxTranslate }}{{ subtotal | async |currency:defaultCurrencyISO }} {{ 'productDetails.taxIncluded' | cxTranslate }} </div>
  }
  <mat-grid-list cols="2" rowHeight="4:1">
    <mat-grid-tile class="udxaddToCart">
      @if(!usjfeature) {
        <button class="btn btn-primary btn-block" type="submit" [disabled]="isAddToCartDisabled">
          {{ 'addToCart.addToCart' | cxTranslate }}
        </button>
      }
      @else {
      <button class="btn btn-secondary btn-block" type="submit" [disabled]="isAddToCartDisabled">
        {{ 'addToCart.addToCart' | cxTranslate }}
      </button>
    }
  </mat-grid-tile>
</mat-grid-list>
</div>
} @else {
  @if (product.ticketEntries != undefined) {
    <span class="label-font">{{
      'pdp.selectPackages' | cxTranslate
    }}</span>
  } @else {
    <span class="label-font">{{ 'pdp.quantity' | cxTranslate }}</span>
  }
  <div class="row">
    <div class="cx-counter-stock mt-2 mb-4">
      @if (product.maxQty !== undefined) {
        @if (hasStock) {
          <app-item-counter
            [max]="toNumber(product.maxQty)"
            [min]="product.minQty ? toNumber(product.minQty) : 1"
            [control]="$any(addToCartForm.get('quantity'))"
            (quantityChanged)="onQuantityChanged($event,product.hideOnCart)"
          ></app-item-counter>
        }
      }
      @if (product.maxQty === undefined) {
        @if (hasStock) {
          <app-item-counter
            [min]="product.minQty ? toNumber(product.minQty) : 1"
            [control]="$any(addToCartForm.get('quantity'))"
            (quantityChanged)="onQuantityChanged($event,product.hideOnCart)"
          ></app-item-counter>
        }
      }
      <!-- <div class="stock mt-2" *ngIf="product.stock?.stockLevelStatus === 'outOfStock'">
      <small class="group-type-age-label"><b>{{ 'addToCart.outOfStock' | cxTranslate }}</b></small>
    </div> -->
    <!-- <span class="info">
    <span *ngIf="showInventory$ | async">{{ getInventory() }}</span>
    {{ hasStock ? ('addToCart.inStock' | cxTranslate) : ('addToCart.outOfStock' | cxTranslate) }}</span
    > -->
  </div>
  @if (product.stock?.stockLevelStatus === 'outOfStock') {
    <div class="col m-2">
      <div class="text-danger">
        <small class="group-type-age-label"
          ><b>{{ 'addToCart.outOfStock' | cxTranslate }}</b></small
          >
        </div>
      </div>
    }
    @if (product.stock?.stockLevelStatus !== 'outOfStock') {
      <div class="col m-2">
        @if(currentBaseSite == 'b2bportal'){
          <small class="group-type-age-label">
            <!-- <b *ngIf="product.minQty">{{ 'common.productMinVal' | cxTranslate : { minVal: product.minQty } }}</b>
            <b *ngIf="product.minQty && product.maxQty">, </b>
            <b *ngIf="product.maxQty">{{ 'common.productMaxVal' | cxTranslate : { maxVal: product.maxQty } }}</b> -->
            (
            {{ product.minQty }}
            ~
            {{ product.maxQty }}
            )
          </small>
        }
      </div>
    }
  </div>
  @if (product.digitalEntries != undefined || product.ticketEntries != undefined) {
    <div class="container">
      <span class="label-font">{{ 'pdp.packagedetails' | cxTranslate }}</span>
      <div class="row">
        @if (product.digitalEntries != undefined) {
          @for (digital of product.digitalEntries; track digital) {
            <div>
              <mat-card>
                <div>
                  <b>{{ digital.name }}</b>
                  <br />
                  <br />
                  {{ 'pdp.quantity' | cxTranslate }} {{ digital.quantity }}
                </div>
              </mat-card>
            </div>
          }
        }
        @if (product.ticketEntries != undefined) {
          @for (ticket of product.ticketEntries; track ticket) {
            <div>
              <mat-card>
                <div>
                  <b>{{ ticket.name }}</b>
                  <br />
                  <br />
                  {{ 'pdp.quantity' | cxTranslate }} {{ ticket.quantity }}
                </div>
              </mat-card>
            </div>
          }
        }
      </div>
    </div>
  }
}
<!-- Inset here -->
</div>
</div>
} @else {
  @if (hasStock) {
    <button
      [ngClass]="options.displayAddToCart ? 'link cx-action-link' : 'btn btn-primary btn-block'"
      type="submit"
      [disabled]="quantity <= 0 || quantity > maxQuantity"
      >
      {{ options.addToCartString ?? ('addToCart.addToCart' | cxTranslate) }}
    </button>
  }
}
</form>
}